import { jwtDecode } from "@smp/utils";

import { IMqPermissions } from "./ws.types";

export const getMqPemissions = (jwt?: string): IMqPermissions | undefined => {
  const jwtDecoded = jwt ? jwtDecode(jwt) : undefined;

  if (!jwtDecoded) {
    return undefined;
  }

  const { iss, scp, sub }: { iss: string; scp: string[]; sub: number } =
    jwtDecoded;
  const scopes: Map<string, string[]> = new Map();

  scp.forEach((scope) => {
    if (!scope.includes("mq")) {
      return;
    }

    const permission = scope.slice(0, scope.lastIndexOf(":"));
    const rules = scope.split(":").reverse()[0].split("");

    scopes.set(permission, rules);
  });

  return {
    iss,
    sub,
    scopes,
  };
};
